import { ReactComponent as TrendUpIcon } from 'assets/icons/business/trend-up.svg';

export const business = {
  'trend-up': TrendUpIcon,
};
